import React, {useState, useEffect, useRef, useContext} from 'react';
import {toast} from 'react-toastify';
import {CustomInput, Input, InputGroup, Button} from 'reactstrap';
import SearchOperatorsModal from './modals/SearchOperatorsModal';
import SearchInput from './SearchInput';
import SpinnerButton from 'components/SpinnerButton';
import SavedSearchArticleList from './SavedSearchArticleList';
import {SavedSearchContext} from 'contexts/SavedSearchContext';
import Loader from 'components/Loader';
import {ErrorContext} from 'contexts/ErrorContext';
import Tooltip from 'components/Tooltip';

const SavedSearchView = (props) => {
    const {
        activeSavedSearch, savedSearchPeriodFilter,
        activeSavedSearchSort, savedSearchSocialFilters, savedSearchSentimentFilters,
        setSavedSearchSentimentCount, setSavedSearchSocialCount,
    } = useContext(SavedSearchContext);

    const {
        inTitleOnly, searchResults, titleValue, keywordSearchValue, setKeywordSearchValue,
        tempTitleValue, error, submitSSData, setEditMode, handleTitleInput,
        handleTitleInputBlur, toggleInTitleOnly, toggleEditMode, editMode,
        totalCount, resetSearchValues, selectedEntities, getSearchResultsByKeyword,
        updatingSSFilters, loading, submitting, updatingSSInfo,
    } = props;

    const titleInputRef = useRef(null);
    const savedSearchNewsContainer = useRef(null);

    const [end, setEnd] = useState(50);
    const [heightForVirtualization, setHeightForVirtualization] = useState('0px');
    const [scrollPositionForAdjusting, setScrollPositionForAdjusting] = useState(0);

    useEffect(() => {
        if(searchResults && savedSearchNewsContainer && savedSearchNewsContainer.current) {
            setHeightForVirtualization(getDynamicalHeight(searchResults) + 'px');
            setScrollPositionForAdjusting(getDynamicalHeight(searchResults.slice(0, 50)) - savedSearchNewsContainer.current.clientHeight - 395);
            // setScrollPositionForAdjusting(getDynamicalHeight(searchResults.slice(0, 50)) - savedSearchNewsContainer.current.clientHeight - 500);
            setEnd(50);
            savedSearchNewsContainer.current.scrollTop = 0;
        }
    }, [searchResults]);

    const listVirt = () => {
        if(searchResults && (savedSearchNewsContainer.current.scrollTop > scrollPositionForAdjusting)) {
            setScrollPositionForAdjusting(scrollPositionForAdjusting + getDynamicalHeight(searchResults.slice(end, end + 50)));
            setEnd(end + 50);
        }
    };

    const getDynamicalHeight = (list) => {
        let finalHeight = 0;
        let listArr = list ? list : [];
        listArr.forEach(listItem => {
            if(listItem.title && listItem.title.length < 100) {
                finalHeight += 73;
            } else {
                finalHeight += 100;
            }
            if(listItem.abstract && listItem.abstract.trim() !== '') {
                if(listItem.abstract.length < 140) {
                    finalHeight += 21;
                } else if(listItem.abstract.length > 140 && listItem.abstract.length < 280) {
                    finalHeight += 42;
                } else {
                    finalHeight += 63;
                }
            }
        });
        return finalHeight;
    };

    const handlePressEnter = (e) => {
        setEditMode(false);
        handleTitleInputBlur(e);
    };

    return (
        <div className="home-page__center-inner saved-searches-form" ref={savedSearchNewsContainer}
             onScroll={(e) => listVirt(e)}>
            <div className="w-100 d-flex flex-column">
                <SearchInput
                    onSubmit={() => activeSavedSearch ? submitSSData() : getSearchResultsByKeyword()}
                    value={keywordSearchValue}
                    handleChange={setKeywordSearchValue}
                    loading={loading || updatingSSFilters || updatingSSInfo}
                    inputPlaceholder="Follow people, events and more"
                    clear={resetSearchValues}
                />
                {error && error.keyword && <div className="error-text">{error.keyword[0].message}</div>}
            </div>
            <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                    <CustomInput
                        id="in_title_only"
                        type="checkbox"
                        checked={inTitleOnly}
                        onChange={toggleInTitleOnly}
                    />
                    <div>In title only</div>
                </div>
                <SearchOperatorsModal/>
            </div>
            {(searchResults || activeSavedSearch) &&
            <>
                {editMode ?
                    <InputGroup style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '5px',
                        marginBottom: '5px',
                    }}>
                        <Input
                            onChange={(e) => handleTitleInput(e.target.value)}
                            onBlur={handleTitleInputBlur}
                            onKeyPress={(e) => e.key === 'Enter' ? handlePressEnter(e) : false}
                            value={titleValue || tempTitleValue}
                            placeholder="Saved Search Name"
                            type="text"
                            style={{paddingRight: '35px', height: '45px', fontSize: '17px'}}
                            autoComplete="off"
                            id="saved-search-name-edit"
                            innerRef={titleInputRef}
                        />
                    </InputGroup>
                    :
                    <div className="saved-searches-form__title-container">
                        <div className="d-flex">
                            <div className="saved-searches-form__title">
                                {titleValue ? titleValue : tempTitleValue}
                            </div>
                            {(titleValue || tempTitleValue) &&
                            <Tooltip placement="bottom" wide tooltip={`Rename`}>
                                <i
                                    className="feedsActions ml-2 fas fa-pencil-alt"
                                    onClick={toggleEditMode}
                                />
                            </Tooltip>
                            }
                        </div>
                        {!activeSavedSearch &&
                        <SpinnerButton
                            style={{minWidth: '80px', marginLeft: '10px'}}
                            disabled={titleValue.length > 990 || selectedEntities.length === 0}
                            onClick={() => submitSSData(null, null, true)}
                            className="btn calltoaction-button"
                            submitting={submitting}
                            title={activeSavedSearch ? 'Update' : 'Save'}
                        />
                        }
                    </div>
                }
            </>
            }
            {/*{(fetchingSearchResults || fetchingActiveSavedSearch) ?*/}
            {(loading) ?
                <div className="d-flex align-items-center justify-content-center" style={{marginTop: '5rem'}}>
                    {/*<i className="fa fa-spinner fa-spin"/>*/}
                    <Loader small text="Fetching search data"/>
                </div>
                :
                <>
                    {selectedEntities.length === 0 ?
                        <div className="mt-3">No entities are currently selected. Search parameters will not be
                            saved.</div>
                        : searchResults !== null &&
                        <SavedSearchArticleList
                            searchResults={searchResults}
                            socialFilters={savedSearchSocialFilters}
                            sentimentFilters={savedSearchSentimentFilters}
                            activeSort={activeSavedSearchSort}
                            heightForVirtualization={heightForVirtualization}
                            end={end}
                            periodFilter={savedSearchPeriodFilter}
                            setSentimentCount={setSavedSearchSentimentCount}
                            setSocialCount={setSavedSearchSocialCount}
                            activeEntitiesForSavedSearch={selectedEntities}
                            totalCount={totalCount}
                        />
                    }
                </>
            }
        </div>
    );
};

export default SavedSearchView;
